import styled from 'styled-components';

export const UiTitle = styled.h3`
	width: 100%;
	color: #242c3f;
	margin-bottom: 1.5rem;
`;

